export const table_font_variant: 'body1' | 'body2' | 'subtitle1' | 'subtitle2' = 'body1';
export const collapsibles_font_variant: 'body1' | 'body2' | 'subtitle1' | 'subtitle2' = 'subtitle2';
